import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { HelmetProvider } from "react-helmet-async";

import "@amzn/awsui-global-styles/polaris.css";
import App from "./App";
import { ShortbreadProvider } from "./contexts/shortbread";
// import reportWebVitals from './reportWebVitals';

const queryClient = new QueryClient();

document.body.classList.add("awsui-visual-refresh");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <ShortbreadProvider>
        <App />
      </ShortbreadProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
